// @flow

import React from "react";
import { localize } from "redux-i18n";
import { Modal, ModalBody, ModalFooter, ModalHeader, Button } from "@components";
import type { EmployeeType } from "@modules/employee/types";
import type { EmployeeAbsence } from "@modules/shared/reducer/employee-absences/types";

type OwnProps = $Exact<{
  onDismissHandler: Function,
  onSubmitHandler: Function,
  employeeFrom: EmployeeType,
  employeeTo: EmployeeType,
  absence: EmployeeAbsence,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export class TransferAbsenceConfirmationModal extends React.Component<Props> {
  render() {
    return (
      <Modal className="modal-small">
        <ModalHeader>{this.props.t("TRANSFER_ABSENCE")}</ModalHeader>
        <ModalBody>
          {this.props.t("TRANSFER_ABSENCE_CONFIRMATION_TEXT", {
            absenceId: this.props.absence.id,
            fromName: `${this.props.employeeFrom.firstName} ${this.props.employeeFrom.lastName}`,
            toName: `${this.props.employeeTo.firstName} ${this.props.employeeTo.lastName}`,
          })}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={this.props.onDismissHandler}>
            {this.props.t("CANCEL")}
          </Button>
          <Button onClick={this.props.onSubmitHandler}>{this.props.t("TRANSFER")}</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default localize()(TransferAbsenceConfirmationModal);
